import type {
  ShareBundleAccessesResponse,
  ShareBundleCreateBody,
  ShareBundleCreateResponse,
  ShareBundleListResponse,
} from "@bitacorapro/api-types";
import { request } from "../client";

export const shareBundlesApi = {
  create: (body: ShareBundleCreateBody): Promise<ShareBundleCreateResponse> =>
    request<ShareBundleCreateResponse>("POST", "core", "/share-bundles", { body }),
  list: (): Promise<ShareBundleListResponse> =>
    request<ShareBundleListResponse>("GET", "core", "/share-bundles"),
  revoke: (id: string): Promise<null> => request<null>("DELETE", "core", `/share-bundles/${id}`),
  accesses: (id: string): Promise<ShareBundleAccessesResponse> =>
    request<ShareBundleAccessesResponse>("GET", "core", `/share-bundles/${id}/accesses`),
};
